module.exports = __webpack_public_path__ + "images/emoji/suspension_railway.1134b510f22f6d0454e9.png";